/* AVIXIA homepage: collection filter buttons */
(function () {
  function init(root) {
    if (!root || root.getAttribute('data-avx-ready') === 'true') return;
    root.setAttribute('data-avx-ready', 'true');

    var chips = root.querySelectorAll('[data-avx-filter]');
    var tiles = root.querySelectorAll('.avx-tile');
    var rows = root.querySelectorAll('.avx-tile-row');

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var filter = chip.getAttribute('data-avx-filter');

        chips.forEach(function (other) {
          other.setAttribute('aria-pressed', other === chip ? 'true' : 'false');
        });

        tiles.forEach(function (tile) {
          var cats = (tile.getAttribute('data-cats') || '').split(' ');
          tile.hidden = !(filter === 'all' || cats.indexOf(filter) !== -1);
        });

        rows.forEach(function (row) {
          row.hidden = row.querySelectorAll('.avx-tile:not([hidden])').length === 0;
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-avx-collection]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Keep working inside the Shopify theme editor when a section is reloaded.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-avx-collection]');
    if (root) {
      root.removeAttribute('data-avx-ready');
      init(root);
    }
  });
})();
